/**
 * Once-per-window gate for raw `fetch` callers that a hook or query can re-run
 * far more often than the data changes (presence heartbeat, payment banner,
 * enterprise status).
 *
 * 2026-09-17: a Safari 26 tab re-ran those three ~13×/s after login for 2.5 min
 * — 5,700 req/min from one browser. They bypass the axios client, so nothing
 * shared could dedupe them. Within `minIntervalMs` every caller gets the SAME
 * promise (in-flight or settled); a rejection clears the slot so a retry can
 * still reach the network.
 */
const slots = new Map<string, { at: number; promise: Promise<unknown> }>();

export function rateGate<T>(key: string, minIntervalMs: number, fn: () => Promise<T>): Promise<T> {
  const now = Date.now();
  const hit = slots.get(key);
  if (hit && now - hit.at < minIntervalMs) return hit.promise as Promise<T>;
  const promise = fn().catch((err) => {
    if (slots.get(key)?.promise === promise) slots.delete(key);
    throw err;
  });
  slots.set(key, { at: now, promise });
  return promise;
}
